import React from "react";
import AddModule from "./AddModule";

type Props = {
  moduleItems: any;
  moduleIsLoading: any;
};

const AddModuleWrapper = ({
  moduleItems,
  moduleIsLoading,
}: Props) => {
  return (
    <>
      <AddModule
        items={moduleItems}
        moduleIsLoading={moduleIsLoading}
      />
    </>
  );
};

export default AddModuleWrapper;
